import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, TextField, MenuItem, CircularProgress } from "@mui/material";

const ShiftHandoverDialog = ({ open, onClose, banks = [], handoverData = {}, onChange = () => {}, onSubmit = () => {}, loading = false }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>ترحيل النقدية</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 1 }}>
          <TextField
            select
            label="من الخزنة"
            name="from_bank_id"
            value={handoverData.from_bank_id || ""}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value="">اختر</MenuItem>
            {banks.map((bank) => (
              <MenuItem key={bank.id} value={bank.id}>
                {bank.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="إلى الخزنة"
            name="to_bank_id"
            value={handoverData.to_bank_id || ""}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value="">اختر</MenuItem>
            {banks.map((bank) => (
              <MenuItem key={bank.id} value={bank.id}>
                {bank.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="المبلغ"
            name="amount"
            type="text"
            value={handoverData.amount || ""}
            onChange={onChange}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">إلغاء</Button>
        <Button onClick={onSubmit} variant="contained" color="primary" disabled={loading}>
          {loading ? <CircularProgress size={18} /> : "ترحيل"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShiftHandoverDialog;
